<template>
  <section class="container page-py" dir="ltr">
    <div
      class="bread-crumbs"
      itemscope
      itemtype="http://schema.org/BreadcrumbList"
    >
      <div
        class="navigate-info"
        itemprop="itemListElement"
        itemscope
        itemtype="http://schema.org/ListItem"
      >
        <nuxt-link
          to="/blog"
          class="navigate-info-route"
          itemprop="item"
        >
          <meta itemprop="position" content="1" />
          {{ $t('Blog') }} </nuxt-link
        ><span class="navigate-info__arrow">></span
        ><span class="navigate-info__span" itemprop="name">{{
          $t('artTitle8')
        }}</span
        ><meta itemprop="position" content="2" />
      </div>
    </div>
    <h1>{{ $t('artTitle8') }}</h1>
    <p>{{ $t('artText8-1') }}</p>
    <img
      :src="`${staticUrl}/images/Revolutionizing_Spatial_Design_with_DreamFlat_A_Seamless_Approach_to_Floor_Planning.webp`"
      :alt="'altImageDefault'"
    />
    <h2>{{ $t('artText8-2') }}</h2>
    <p>{{ $t('artText8-3') }}</p>
    <h2>{{ $t('artText8-4') }}</h2>
    <p>{{ $t('artText8-5') }}</p>
    <h2>{{ $t('artText8-6') }}</h2>
    <p>{{ $t('artText8-7') }}</p>
    <h2>{{ $t('artText8-8') }}</h2>
    <p>{{ $t('artText8-9') }}</p>
    <h2>{{ $t('artText8-10') }}</h2>
    <p>{{ $t('artText8-11') }}</p>
    <h2>{{ $t('artText8-12') }}</h2>
    <p>{{ $t('artText8-13') }}</p>
    <h2>{{ $t('artText8-14') }}</h2>
    <p>{{ $t('artText8-15') }}</p>
    <h2>{{ $t('artText8-16') }}</h2>
    <p>{{ $t('artText8-17') }}</p>
    <img
      :src="`${staticUrl}/images/Revolutionizing_Spatial_Design_with_DreamFlat_A_Seamless_Approach_to_Floor_Planning_1.webp`"
      :alt="'altImageDefault'"
    />
    <h2>{{ $t('artText8-18') }}</h2>
    <p>{{ $t('artText8-19') }}</p>
  </section>
</template>

<script setup lang="ts">
import {useI18n} from 'vue-i18n';

const runtimeConfig = useRuntimeConfig();
const staticUrl = runtimeConfig.public.vueAppStaticUrl;
const {t} = useI18n();

useSeoMeta({
  title: `${t('artSeoTitle8')}`,
  ogTitle: `${t('artSeoTitle8')}`,
  description: `${t('artSeoDesc8')}`,
  ogDescription: `${t('artSeoDesc8')}`,
  ogImage: 'https://dreamflat.design/prev.webp',
  twitterCard: 'summary_large_image',
});
</script>

<style scoped lang="scss">
@import 'css/blog/blog';
</style>
